import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { MainService } from "@/services/main.service";
import { ref, onMounted, onBeforeUnmount } from 'vue';

export interface CameraProps {
  workId?: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CameraFeed',
  props: {
    workId: {}
  },
  setup(__props: any) {

const { workId } = __props;

const videoContainer = ref<any>(null);
const video = ref<HTMLVideoElement>();

const mediaStream = ref<MediaStream | null>();

const setupWebcam = async () => {
  try {
    mediaStream.value = await navigator.mediaDevices.getUserMedia({ video: true });

    if (video.value) {
      video.value.srcObject = mediaStream.value;
      video.value.addEventListener('loadedmetadata', () => video.value?.play())
    }
  } catch (error) {
    console.error('Error accessing webcam: ', error);
  }
};

function uploadCameraFrame() {
  if (mediaStream.value == null) return
  if (video.value == undefined) return
  if (workId == undefined) return
  const canvas = document.createElement('canvas');
  canvas.width = 320
  canvas.height = 240

  const context = canvas.getContext('2d');
  if (context == undefined) return
  context.drawImage(video.value, 0, 0, canvas.width, canvas.height);

  canvas.toBlob(blob => {
    if (blob == undefined) return
    const file = new File([blob], "image.jpg", { type: "image/jpeg" });
    MainService.uploadImage(workId, file)
      .then(rsp => console.log("Image uploaded"))
      .catch(e => console.log("Image upload failed"))
  }, "image/jpeg", 0.7);
}

const imageInterval = setInterval(() => uploadCameraFrame(), 5000)

onMounted(() => {
  setupWebcam();
});

onBeforeUnmount(() => {
  if (mediaStream.value) {
    mediaStream.value.getTracks().forEach((track) => track.stop());
  }
  clearInterval(imageInterval)
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      ref_key: "videoContainer",
      ref: videoContainer,
      class: "mx-auto d-block text-center"
    }, [
      _createElementVNode("video", {
        ref_key: "video",
        ref: video,
        width: "100%",
        height: "100%",
        autoplay: ""
      }, null, 512)
    ], 512)
  ]))
}
}

})